import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import {
	componentPagesMenu,
	dashboardPagesMenu,
	clerkPageMenu,
	demoPagesMenu,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../menu';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/presentation/auth/Login';
// import ClerkDashboard from '../pages/Dashboard_new/ClerkDashboard';
import AllProduct from '../pages/extra/Product/AllProduct';
import AllCategory from '../pages/extra/Category';
import AddCategory from '../pages/extra/Category/AddCategory';
import Banner from '../pages/extra/Banner';
import AddBanner from '../pages/extra/Banner/AddBanner';
import EditBanner from '../pages/extra/Banner/EditBanner';

import AllUsers from '../pages/extra/Users/AllUsers';
import AddUser from '../pages/extra/Users/AddUser';
import EditUser from '../pages/extra/Users/EditUser';
import EditCategory from '../pages/extra/Category/EditCategory';
import AddProduct from '../pages/extra/Product/AddProduct';
import EditProduct from '../pages/extra/Product/EditProduct';

import CateringBanner from '../pages/catering/Banner';
import AddCateringBanner from '../pages/catering/Banner/AddBanner';
import EditCateringBanner from '../pages/catering/Banner/EditBanner';

import AllOrders from '../pages/extra/Order';
import OrderDetail from '../pages/extra/Order/OrderDetail';
import EditOrder from '../pages/extra/Order/EditOrder';
import AddOrder from '../pages/extra/Order/AddOrder';

import AllVendors from '../pages/extra/Vendor/AllVendors';
import EditVendor from '../pages/extra/Vendor/EditVendor';
import AddVendor from '../pages/extra/Vendor/AddVendor';

//Catering
import AllEventType from '../pages/catering/EventType/AllEventTypes';
import EditEventTpe from '../pages/catering/EventType/EditEventType';
import AddEventType from '../pages/catering/EventType/AddEventType';

import AllFoodCatering from '../pages/catering/FoodCatering/AllFoodCatering';
import EditFoodCatering from '../pages/catering/FoodCatering/EditFoodCatering';
import AddFoodCatering from '../pages/catering/FoodCatering/AddFoodCatering';

import AllPartyAccessories from '../pages/catering/PartyAccessories/AllPartyAccessories';
import EditPartyAccessories from '../pages/catering/PartyAccessories/EditPartyAccesories';
import AddPartyAccessories from '../pages/catering/PartyAccessories/AddPartyAccessories';

import AllCateringPrice from '../pages/catering/CateringPrice/AllCateringPrice';
import AllPartyCatering from '../pages/catering/PartyCatering/AllPartyCatering';
import EditPartyCatering from '../pages/catering/PartyCatering/EditPartyCatering';

import AddPartyCatering from '../pages/catering/PartyCatering/AddPartyCatering';
import Booking from '../pages/catering/Booking/AllBooking';
import EditBooking from '../pages/catering/Booking/EditBooking';

import CateringOrder from '../pages/catering/Order/AllOrder';
import EditCateringOrder from '../pages/catering/Order/EditOrder';

import AllGifts from '../pages/Gift/AllGifts';
import AddGift from '../pages/Gift/AddGift';
import EditGift from '../pages/Gift/EditGift';

import AllLoyalities from '../pages/Loyality/AllLoyalities';
// import AddGift from '../pages/Gift/AddGift';
import EditLoyality from '../pages/Loyality/EditLoyality';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/Dashboard_new/MainDashboard')),
	CLERKDASHBOARD: lazy(() => import('../pages/Dashboard_new/ClerkDashboard')),
	// MAINDASHBOARD: lazy(() => import('../pages/Dashboard_new/MainDashboard')),

	//customer
	CUSTOMERDASHBOARD: lazy(() => import('../pages/USERSCRUDS/CUSTOMERCRUD/Customer')),
	CUSTOMEREDIT: lazy(() => import('../pages/USERSCRUDS/CUSTOMERCRUD/Edit')),
	// CUSTOMERADD:lazy(()=>import('../pages/USERSCRUDS/CUSTOMERCRUD/CustomerAdd')),
	CUSTOMERVIEW: lazy(() => import('../pages/USERSCRUDS/CUSTOMERCRUD/CustomerView')),
	CUSTOMERVIEWALL: lazy(() => import('../pages/USERSCRUDS/CUSTOMERCRUD/Allusers')),

	//driver
	DRIVERDASHBOARD: lazy(() => import('../pages/USERSCRUDS/DRIVERCRUD/Driver')),
	DRIVERADD: lazy(() => import('../pages/USERSCRUDS/DRIVERCRUD/DriverAdd')),
	DRIVEREDIT: lazy(() => import('../pages/USERSCRUDS/DRIVERCRUD/DriverEditModal')),
	DRIVERVIEW: lazy(() => import('../pages/USERSCRUDS/DRIVERCRUD/DiverView')),

	//    mode

	MODE: lazy(() => import('../pages/USERSCRUDS/Mode/Mode')),

	ContentManagement: lazy(
		() => import('../pages/USERSCRUDS/ContentManagement/ContentManagement'),
	),
	CONTENT: lazy(() => import('../pages/USERSCRUDS/Content')),
	FANDQ: lazy(() => import('../pages/USERSCRUDS/FaQ')),
	TERMS: lazy(() => import('../pages/USERSCRUDS/Terms')),

	//Resturant
	// RESORTDASHBOARD :lazy(()=> import('../pages/USERSCRUDS/RESORTCRUD/Resort')),
	// RESORTVIEW :lazy(()=> import('../pages/USERSCRUDS/RESORTCRUD/ResortView')),

	ORDERDASHBOARD: lazy(() => import('../pages/USERSCRUDS/Order/AllOrder/Allorder_order')),
	ORDERVIEW: lazy(() => import('../pages/USERSCRUDS/Order/OrderViewpage')),
	// Resturant new
	RESTAURANT: lazy(() => import('../pages/USERSCRUDS/RESTAURANT/List_RESTAURANT')),
	ADD_RESTAURANT: lazy(
		() => import('../pages/USERSCRUDS/RESTAURANT/ADD_RESTAURANT/ADD_RESTAURANT'),
	),
	EDIT_RESTAURANT: lazy(
		() => import('../pages/USERSCRUDS/RESTAURANT/Edit_Restaurant/Edit_Restaurant'),
	),
	VIEW_RESTAURANT: lazy(
		() => import('../pages/USERSCRUDS/RESTAURANT/view_RESTAURANT/view_RESTAURANT'),
	),

	//product
	PRODUCTGRID: lazy(() => import('../pages/Product/Product Grid/ProductGrid')),
	PRODUCTLIST: lazy(() => import('../pages/Product/Product List/ProductList')),
	PVDCRUD: lazy(() => import('../pages/USERSCRUDS/PVD/PvdCrud')),

	// order

	ALL_ORDER: lazy(() => import('../pages/USERSCRUDS/Order/AllOrder/Allorder_order')),

	//transctions
	DRIVER_TRA: lazy(() => import('../pages/USERSCRUDS/Transaction/Driver_tra')),
	RESTAURANT_TRA: lazy(() => import('../pages/USERSCRUDS/Transaction/Restaurant_tra')),
	USER_TRA: lazy(() => import('../pages/USERSCRUDS/Transaction/User_tra')),

	// Menu

	MENU: lazy(() => import('../pages/USERSCRUDS/Menu/Menu')),

	MENU_ITEMS: lazy(() => import('../pages/USERSCRUDS/Menu/Items/Items')),
	MENU_VIEW: lazy(() => import('../pages/USERSCRUDS/Menu/Items/view_items')),

	MENU_CATEGORY: lazy(() => import('../pages/USERSCRUDS/Menu/Category/Category')),
	MENU_ADDON: lazy(() => import('../pages/USERSCRUDS/Menu/AddOnn/Addons')),

	MENU_TAGS: lazy(() => import('../pages/USERSCRUDS/Menu/Tags/Tags')),
	//menu
	// MENU:lazy(()=>import('../pages/Menu/Menu')),

	//Inderients
	INGREDIENTS: lazy(() => import('../pages/ingredients/ingredients')),

	DASHBOARD_BOOKING: lazy(() => import('../pages/presentation/dashboard/DashboardBookingPage')),
	SUMMARY: lazy(() => import('../pages/presentation/SummaryPage')),
};
const SINGLE = {
	BOXED: lazy(() => import('../pages/presentation/single-pages/SingleBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/single-pages/SingleFluidPage')),
};
const LIST = {
	BOXED: lazy(() => import('../pages/presentation/demo-pages/ListBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/ListFluidPage')),
};
const GRID = {
	BOXED: lazy(() => import('../pages/presentation/demo-pages/GridBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/GridFluidPage')),
};
const EDIT = {
	MODERN: lazy(() => import('../pages/presentation/demo-pages/EditModernPage')),
	BOXED: lazy(() => import('../pages/presentation/demo-pages/EditBoxedPage')),
	FLUID: lazy(() => import('../pages/presentation/demo-pages/EditFluidPage')),
	WIZARD: lazy(() => import('../pages/presentation/demo-pages/EditWizardPage')),
	IN_CANVAS: lazy(() => import('../pages/presentation/demo-pages/EditInCanvasPage')),
	IN_MODAL: lazy(() => import('../pages/presentation/demo-pages/EditInModalPage')),
};
const PRICING = {
	PRICING_TABLE: lazy(() => import('../pages/presentation/pricing/PricingTablePage')),
};

const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const APP = {
	PROJECT_MANAGEMENT: {
		PROJECTS_LIST: lazy(
			() => import('../pages/presentation/project-management/ProjectManagementsList'),
		),
		PROJECT: lazy(
			() => import('../pages/presentation/project-management/ProjectManagementsProject'),
		),
	},
	KNOWLEDGE: {
		GRID: lazy(() => import('../pages/presentation/knowledge/KnowledgeGridPage')),
		VIEW: lazy(() => import('../pages/presentation/knowledge/KnowledgeViewPage')),
	},
	SALES: {
		TRANSACTIONS: lazy(() => import('../pages/presentation/sales/TransActionsPage')),
		PRODUCTS: lazy(() => import('../pages/presentation/sales/SalesListPage')),
		PRODUCTS_GRID: lazy(() => import('../pages/presentation/sales/ProductsGridPage')),
		PRODUCTS_VIEW: lazy(() => import('../pages/presentation/sales/ProductViewPage')),
	},
	APPOINTMENT: {
		CALENDAR: lazy(() => import('../pages/presentation/appointment/CalendarPage')),
		EMPLOYEE_LIST: lazy(() => import('../pages/presentation/appointment/EmployeeList')),
		EMPLOYEE_VIEW: lazy(() => import('../pages/presentation/appointment/EmployeePage')),
		APPOINTMENT_LIST: lazy(() => import('../pages/presentation/appointment/AppointmentList')),
	},
	CRM: {
		CRM_DASHBOARD: lazy(() => import('../pages/presentation/crm/CrmDashboard')),
		CUSTOMERS: lazy(() => import('../pages/presentation/crm/CustomersList')),
		CUSTOMER: lazy(() => import('../pages/presentation/crm/CustomersList')),
	},
	CHAT: {
		WITH_LIST: lazy(() => import('../pages/presentation/chat/WithListChatPage')),
		ONLY_LIST: lazy(() => import('../pages/presentation/chat/OnlyListChatPage')),
	},
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const CONTENT = {
	CONTENTS: lazy(() => import('../pages/documentation/content/ContentListPage')),
	TYPOGRAPHY: lazy(() => import('../pages/documentation/content/TypographyPage')),
	IMAGES: lazy(() => import('../pages/documentation/content/ImagesPage')),
	TABLES: lazy(() => import('../pages/documentation/content/TablesPage')),
	FIGURES: lazy(() => import('../pages/documentation/content/FiguresPage')),
};
const FORMS_PAGE = {
	FORMS: lazy(() => import('../pages/documentation/forms/FormsListPage')),
	FORM_GROUP: lazy(() => import('../pages/documentation/forms/FormGroupPage')),
	FORM_CONTROLS: lazy(() => import('../pages/documentation/forms/FormControlsPage')),
	SELECT: lazy(() => import('../pages/documentation/forms/SelectPage')),
	CHECKS_AND_RADIO: lazy(() => import('../pages/documentation/forms/ChecksAndRadioPage')),
	RANGE: lazy(() => import('../pages/documentation/forms/RangePage')),
	INPUT_GROUP: lazy(() => import('../pages/documentation/forms/InputGroupPage')),
	VALIDATION: lazy(() => import('../pages/documentation/forms/ValidationPage')),
	WIZARD: lazy(() => import('../pages/documentation/forms/WizardPage')),
};
const GETTING_STARTED = {
	INSTALLATION: lazy(() => import('../pages/documentation/getting-started/InstallationPage')),
	DEVELOPMENT: lazy(() => import('../pages/documentation/getting-started/DevelopmentPage')),
	FOLDER: lazy(() => import('../pages/documentation/getting-started/FolderStructurePage')),
	BOOTSTRAP: lazy(() => import('../pages/documentation/getting-started/BootstrapVariablesPage')),
	PROJECT: lazy(() => import('../pages/documentation/getting-started/ProjectStructurePage')),
};
const ROUTES = {
	ROUTER: lazy(() => import('../pages/documentation/routes/RouterPage')),
};
const COMPONENTS_PAGE = {
	COMPONENTS: lazy(() => import('../pages/documentation/components/ComponentsListPage')),
	ACCORDION: lazy(() => import('../pages/documentation/components/AccordionPage')),
	ALERT: lazy(() => import('../pages/documentation/components/AlertPage')),
	BADGE: lazy(() => import('../pages/documentation/components/BadgePage')),
	BREADCRUMB: lazy(() => import('../pages/documentation/components/BreadcrumbPage')),
	BUTTON: lazy(() => import('../pages/documentation/components/ButtonPage')),
	BUTTON_GROUP: lazy(() => import('../pages/documentation/components/ButtonGroupPage')),
	CARD: lazy(() => import('../pages/documentation/components/CardPage')),
	CAROUSEL: lazy(() => import('../pages/documentation/components/CarouselPage')),
	COLLAPSE: lazy(() => import('../pages/documentation/components/CollapsePage')),
	DROPDOWN: lazy(() => import('../pages/documentation/components/DropdownsPage')),
	LIST_GROUP: lazy(() => import('../pages/documentation/components/ListGroupPage')),
	MODAL: lazy(() => import('../pages/documentation/components/ModalPage')),
	NAVS_TABS: lazy(() => import('../pages/documentation/components/NavsTabsPage')),
	OFF_CANVAS: lazy(() => import('../pages/documentation/components/OffCanvasPage')),
	PAGINATION: lazy(() => import('../pages/documentation/components/PaginationPage')),
	POPOVERS: lazy(() => import('../pages/documentation/components/PopoversPage')),
	PROGRESS: lazy(() => import('../pages/documentation/components/ProgressPage')),
	SCROLLSPY: lazy(() => import('../pages/documentation/components/ScrollspyPage')),
	SPINNER: lazy(() => import('../pages/documentation/components/SpinnersPage')),
	TABLE: lazy(() => import('../pages/documentation/components/TablePage')),
	TOASTS: lazy(() => import('../pages/documentation/components/ToastsPage')),
	TOOLTIP: lazy(() => import('../pages/documentation/components/TooltipPage')),
};
const UTILITIES = {
	UTILITIES: lazy(() => import('../pages/documentation/utilities/UtilitiesListPage')),
	API: lazy(() => import('../pages/documentation/utilities/ApiPage')),
	BACKGROUND: lazy(() => import('../pages/documentation/utilities/BackgroundPage')),
	BORDERS: lazy(() => import('../pages/documentation/utilities/BordersPage')),
	COLORS: lazy(() => import('../pages/documentation/utilities/ColorsPage')),
	DISPLAY: lazy(() => import('../pages/documentation/utilities/DisplayPage')),
	FLEX: lazy(() => import('../pages/documentation/utilities/FlexPage')),
	FLOAT: lazy(() => import('../pages/documentation/utilities/FloatPage')),
	INTERACTIONS: lazy(() => import('../pages/documentation/utilities/InteractionsPage')),
	OVERFLOW: lazy(() => import('../pages/documentation/utilities/OverflowPage')),
	POSITION: lazy(() => import('../pages/documentation/utilities/PositionPage')),
	SHADOWS: lazy(() => import('../pages/documentation/utilities/ShadowsPage')),
	SIZING: lazy(() => import('../pages/documentation/utilities/SizingPage')),
	SPACING: lazy(() => import('../pages/documentation/utilities/SpacingPage')),
	TEXT: lazy(() => import('../pages/documentation/utilities/TextPage')),
	VERTICAL_ALIGN: lazy(() => import('../pages/documentation/utilities/VerticalAlignPage')),
	VISIBILITY: lazy(() => import('../pages/documentation/utilities/VisibilityPage')),
};
const ICONS = {
	ICONS_LIST: lazy(() => import('../pages/documentation/icons/IconsListPage')),
	ICON: lazy(() => import('../pages/documentation/icons/IconPage')),
	MATERIAL: lazy(() => import('../pages/documentation/icons/MaterialPage')),
};
const CHARTS_PAGE = {
	CHART_LIST: lazy(() => import('../pages/documentation/charts/ChartsListPage')),
	GENERAL_USAGE: lazy(() => import('../pages/documentation/charts/ChartGeneralUsagePage')),
	SPARKLINE: lazy(() => import('../pages/documentation/charts/ChartSparklinePage')),
	LINE: lazy(() => import('../pages/documentation/charts/ChartLinePage')),
	AREA: lazy(() => import('../pages/documentation/charts/ChartAreaPage')),
	COLUMN: lazy(() => import('../pages/documentation/charts/ChartColumnPage')),
	BAR: lazy(() => import('../pages/documentation/charts/ChartBarPage')),
	MIXED: lazy(() => import('../pages/documentation/charts/ChartMixedPage')),
	TIMELINE: lazy(() => import('../pages/documentation/charts/ChartTimelinePage')),
	CANDLESTICK: lazy(() => import('../pages/documentation/charts/ChartCandlestickPage')),
	BOX_WHISKER: lazy(() => import('../pages/documentation/charts/ChartBoxWhiskerPage')),
	PIE_DONUT: lazy(() => import('../pages/documentation/charts/ChartPieDonutPage')),
	RADAR: lazy(() => import('../pages/documentation/charts/ChartRadarPage')),
	POLAR: lazy(() => import('../pages/documentation/charts/ChartPolarPage')),
	RADIAL_BAR: lazy(() => import('../pages/documentation/charts/ChartRadialBarPage')),
	BUBBLE: lazy(() => import('../pages/documentation/charts/ChartBubblePage')),
	SCATTER: lazy(() => import('../pages/documentation/charts/ChartScatterPage')),
	HEAT_MAP: lazy(() => import('../pages/documentation/charts/ChartHeatMapPage')),
	TREE_MAP: lazy(() => import('../pages/documentation/charts/ChartTreeMapPage')),
};
const EXTRA = {
	NOTIFICATION: lazy(() => import('../pages/documentation/extras/NotificationPage')),
	HOOKS: lazy(() => import('../pages/documentation/extras/HooksPage')),
};

const presentation: RouteProps[] = [
	// SELF CREATED CRUDS

	/**
	 * Landing
	 */
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <ProtectedRoute roles={['admin']} element={<LANDING.DASHBOARD />} />,
	},
	{
		path: clerkPageMenu.clerkDashboard.path,
		element: <ProtectedRoute roles={['clerk']} element={<LANDING.CLERKDASHBOARD />} />,
	},
	// {
	// 	path: dashboardPagesMenu.maindash.path,
	// 	element: <LANDING.MAINDASHBOARD />,
	// },

	// customer start
	// {
	// 	path: dashboardPagesMenu.user.subMenu.customer.path,
	// 	element: <LANDING.CUSTOMERDASHBOARD />,
	// },

	{
		path: '/customer-edit',
		element: <LANDING.CUSTOMEREDIT />,
	},
	// {
	//     path:"/customer-add",
	// 	element:<LANDING.CUSTOMERADD/>
	// },

	{
		path: `/customer-view/:id`,
		element: <LANDING.CUSTOMERVIEW />,
	},

	{
		path: '/customer-viewall',
		element: <LANDING.CUSTOMERVIEWALL />,
	},
	//customer rend

	// {
	// 	path: dashboardPagesMenu.user.subMenu.driver.path,
	// 	element: <LANDING.DRIVERDASHBOARD />,
	// },
	{
		path: `/driver-view/:id`,
		element: <LANDING.DRIVERVIEW />,
	},

	//store
	// pu
	// {
	// 	path: dashboardPagesMenu.order.path,
	// 	element: <LANDING.ORDERDASHBOARD />,
	// },
	{
		path: '/order-view/:id',
		element: <LANDING.ORDERVIEW />,
	},
	// {
	// 	path:`/resort-view/:id`,
	// 	element: <LANDING.RESORTVIEW />,
	// },
	// mode
	{
		path: dashboardPagesMenu.Mode.path,
		element: <LANDING.MODE />,
	},
	{
		path: dashboardPagesMenu.dashboardBooking.path,
		element: <LANDING.DASHBOARD_BOOKING />,
	},
	{
		path: dashboardPagesMenu.summary.path,
		element: <LANDING.SUMMARY />,
	},

	// resturant new
	// {
	// 	path: dashboardPagesMenu.Restaurnt.path,
	// 	element: <LANDING.RESTAURANT />,
	// },

	{
		path: '/restaurant-add/:id',
		element: <LANDING.ADD_RESTAURANT />,
	},
	{
		path: '/restaurant-edit/:id',
		element: <LANDING.EDIT_RESTAURANT />,
	},
	{
		path: '/restaurant-view/:id',
		element: <LANDING.VIEW_RESTAURANT />,
	},
	// 	// order
	// {
	// 	path: dashboardPagesMenu.ContentManagement.path,
	// 	element: <LANDING.ContentManagement />,
	// },
	// {
	// 	path: dashboardPagesMenu.Content.path,
	// 	element: <LANDING.CONTENT />,
	// },
	{
		path: dashboardPagesMenu.FaQ.path,
		element: <LANDING.FANDQ />,
	},
	{
		path: dashboardPagesMenu.Terms.path,
		element: <LANDING.TERMS />,
	},

	//  	//transctions
	// {
	// 	path: dashboardPagesMenu.transactionHistory.path,
	// 	element: <LANDING.DRIVER_TRA />,
	// },

	//  menu items

	// {
	// 	path: dashboardPagesMenu.menu.path,
	// 	element: <LANDING.MENU_ITEMS />,
	// },
	{
		path: 'menu/items/view/:id',
		element: <LANDING.MENU_VIEW />,
	},
	{
		path: 'menu/category',
		element: <LANDING.MENU_CATEGORY />,
	},
	{
		path: 'menu/addOn',
		element: <LANDING.MENU_ADDON />,
	},
	{
		path: 'menu/tags',
		element: <LANDING.MENU_TAGS />,
	},

	//  {
	// 	path:dashboardPagesMenu.transactionHistory.subMenu.user.path,
	// 	element:<LANDING.USER_TRA/>
	//  },
	// productlist
	// {
	// 	path:dashboardPagesMenu.product.subMenu.product.path,
	// 	element:<LANDING.PRODUCTGRID/>,
	// },

	// {
	// 	path:dashboardPagesMenu.product.subMenu.productList.path,
	// 	element:<LANDING.PRODUCTLIST/>,
	// },
	//Menu
	//    {
	// 	path:dashboardPagesMenu.menu.path,
	// 	element:<LANDING.MENU/>
	//    },
	//Indgerients
	//    {
	// 	path:dashboardPagesMenu.ingredients.path,
	// 	element:<LANDING.INGREDIENTS/>
	//    },
	// {
	// 	path:dashboardPagesMenu.pvd.path,
	// 	element:<LANDING.PVDCRUD/>,

	// },
	/** ************************************************** */

	/**
	 * Pages
	 */

	/**
	 * Single Pages
	 */
	{
		path: demoPagesMenu.singlePages.subMenu.boxedSingle.path,
		element: <SINGLE.BOXED />,
	},
	{
		path: demoPagesMenu.singlePages.subMenu.fluidSingle.path,
		element: <SINGLE.FLUID />,
	},

	/**
	 * List
	 */
	{
		path: demoPagesMenu.listPages.subMenu.listBoxed.path,
		element: <LIST.BOXED />,
	},
	{
		path: demoPagesMenu.listPages.subMenu.listFluid.path,
		element: <LIST.FLUID />,
	},

	/**
	 * Grid
	 */
	{
		path: demoPagesMenu.gridPages.subMenu.gridBoxed.path,
		element: <GRID.BOXED />,
	},
	{
		path: demoPagesMenu.gridPages.subMenu.gridFluid.path,
		element: <GRID.FLUID />,
	},

	/**
	 * Edit
	 */
	{
		path: demoPagesMenu.editPages.subMenu.editModern.path,
		element: <EDIT.MODERN />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editBoxed.path,
		element: <EDIT.BOXED />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editFluid.path,
		element: <EDIT.FLUID />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editWizard.path,
		element: <EDIT.WIZARD />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editInCanvas.path,
		element: <EDIT.IN_CANVAS />,
	},
	{
		path: demoPagesMenu.editPages.subMenu.editInModal.path,
		element: <EDIT.IN_MODAL />,
	},

	{
		path: demoPagesMenu.pricingTable.path,
		element: <PRICING.PRICING_TABLE />,
	},

	/**
	 * END - Pages
	 */

	/**
	 * Auth Page
	 */
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},

	/**
	 * App
	 */

	/**
	 * App > Project Management
	 */
	{
		path: demoPagesMenu.projectManagement.subMenu.list.path,
		element: <APP.PROJECT_MANAGEMENT.PROJECTS_LIST />,
	},
	{
		path: `${demoPagesMenu.projectManagement.subMenu.itemID.path}/:id`,
		element: <APP.PROJECT_MANAGEMENT.PROJECT />,
	},

	/**
	 * App > Knowledge
	 */
	{
		path: demoPagesMenu.knowledge.subMenu.grid.path,
		element: <APP.KNOWLEDGE.GRID />,
	},
	{
		path: `${demoPagesMenu.knowledge.subMenu.itemID.path}/:id`,
		element: <APP.KNOWLEDGE.VIEW />,
	},

	/**
	 * App > Sales
	 */
	{
		path: demoPagesMenu.sales.subMenu.transactions.path,
		element: <APP.SALES.TRANSACTIONS />,
	},
	{
		path: demoPagesMenu.sales.subMenu.salesList.path,
		element: <APP.SALES.PRODUCTS />,
	},
	{
		path: demoPagesMenu.sales.subMenu.productsGrid.path,
		element: <APP.SALES.PRODUCTS_GRID />,
	},
	{
		path: `${demoPagesMenu.sales.subMenu.productID.path}/:id`,
		element: <APP.SALES.PRODUCTS_VIEW />,
	},

	/**
	 * App > Appointment
	 */
	{
		path: demoPagesMenu.appointment.subMenu.calendar.path,
		element: <APP.APPOINTMENT.CALENDAR />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.employeeList.path,
		element: <APP.APPOINTMENT.EMPLOYEE_LIST />,
	},
	{
		path: `${demoPagesMenu.appointment.subMenu.employeeID.path}/:id`,
		element: <APP.APPOINTMENT.EMPLOYEE_VIEW />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.appointmentList.path,
		element: <APP.APPOINTMENT.APPOINTMENT_LIST />,
	},

	/**
	 * App > CRM
	 */
	{
		path: demoPagesMenu.crm.subMenu.dashboard.path,
		element: <APP.CRM.CRM_DASHBOARD />,
	},
	{
		path: demoPagesMenu.crm.subMenu.customersList.path,
		element: <APP.CRM.CUSTOMERS />,
	},
	{
		path: `${demoPagesMenu.crm.subMenu.customerID.path}/:id`,
		element: <APP.CRM.CUSTOMER />,
	},

	/**
	 * App > Chat
	 */
	{
		path: demoPagesMenu.chat.subMenu.withListChat.path,
		element: <APP.CHAT.WITH_LIST />,
	},
	{
		path: demoPagesMenu.chat.subMenu.onlyListChat.path,
		element: <APP.CHAT.ONLY_LIST />,
	},

	/**
	 * END - App
	 */

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const documentation: RouteProps[] = [
	/**
	 * Getting Started
	 */
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.installation.path,
		element: <GETTING_STARTED.INSTALLATION />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.dev.path,
		element: <GETTING_STARTED.DEVELOPMENT />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.folderStructure.path,
		element: <GETTING_STARTED.FOLDER />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.bootstrapVariables.path,
		element: <GETTING_STARTED.BOOTSTRAP />,
	},
	{
		path: gettingStartedPagesMenu.gettingStarted.subMenu.projectStructure.path,
		element: <GETTING_STARTED.PROJECT />,
	},
	/**
	 * Routes
	 */
	{
		path: gettingStartedPagesMenu.routes.subMenu.router.path,
		element: <ROUTES.ROUTER />,
	},
	/**
	 * Bootstrap
	 */

	/**
	 * Content
	 */
	{
		path: componentPagesMenu.content.path,
		element: <CONTENT.CONTENTS />,
	},
	{
		path: componentPagesMenu.content.subMenu.typography.path,
		element: <CONTENT.TYPOGRAPHY />,
	},
	{
		path: componentPagesMenu.content.subMenu.images.path,
		element: <CONTENT.IMAGES />,
	},
	{
		path: componentPagesMenu.content.subMenu.tables.path,
		element: <CONTENT.TABLES />,
	},
	{
		path: componentPagesMenu.content.subMenu.figures.path,
		element: <CONTENT.FIGURES />,
	},

	/**
	 * Forms
	 */
	{
		path: componentPagesMenu.forms.path,
		element: <FORMS_PAGE.FORMS />,
	},
	{
		path: componentPagesMenu.forms.subMenu.formGroup.path,
		element: <FORMS_PAGE.FORM_GROUP />,
	},
	{
		path: componentPagesMenu.forms.subMenu.formControl.path,
		element: <FORMS_PAGE.FORM_CONTROLS />,
	},
	{
		path: componentPagesMenu.forms.subMenu.select.path,
		element: <FORMS_PAGE.SELECT />,
	},
	{
		path: componentPagesMenu.forms.subMenu.checksAndRadio.path,
		element: <FORMS_PAGE.CHECKS_AND_RADIO />,
	},
	{
		path: componentPagesMenu.forms.subMenu.range.path,
		element: <FORMS_PAGE.RANGE />,
	},
	{
		path: componentPagesMenu.forms.subMenu.inputGroup.path,
		element: <FORMS_PAGE.INPUT_GROUP />,
	},
	{
		path: componentPagesMenu.forms.subMenu.validation.path,
		element: <FORMS_PAGE.VALIDATION />,
	},
	{
		path: componentPagesMenu.forms.subMenu.wizard.path,
		element: <FORMS_PAGE.WIZARD />,
	},

	/**
	 * Components
	 */
	{
		path: componentPagesMenu.components.path,
		element: <COMPONENTS_PAGE.COMPONENTS />,
	},
	{
		path: componentPagesMenu.components.subMenu.tooltip.path,
		element: <COMPONENTS_PAGE.TOOLTIP />,
	},
	{
		path: componentPagesMenu.components.subMenu.toasts.path,
		element: <COMPONENTS_PAGE.TOASTS />,
	},
	{
		path: componentPagesMenu.components.subMenu.scrollspy.path,
		element: <COMPONENTS_PAGE.SCROLLSPY />,
	},
	{
		path: componentPagesMenu.components.subMenu.carousel.path,
		element: <COMPONENTS_PAGE.CAROUSEL />,
	},
	{
		path: componentPagesMenu.components.subMenu.spinners.path,
		element: <COMPONENTS_PAGE.SPINNER />,
	},
	{
		path: componentPagesMenu.components.subMenu.listGroup.path,
		element: <COMPONENTS_PAGE.LIST_GROUP />,
	},
	{
		path: componentPagesMenu.components.subMenu.breadcrumb.path,
		element: <COMPONENTS_PAGE.BREADCRUMB />,
	},
	{
		path: componentPagesMenu.components.subMenu.collapse.path,
		element: <COMPONENTS_PAGE.COLLAPSE />,
	},
	{
		path: componentPagesMenu.components.subMenu.pagination.path,
		element: <COMPONENTS_PAGE.PAGINATION />,
	},
	{
		path: componentPagesMenu.components.subMenu.progress.path,
		element: <COMPONENTS_PAGE.PROGRESS />,
	},
	{
		path: componentPagesMenu.components.subMenu.card.path,
		element: <COMPONENTS_PAGE.CARD />,
	},
	{
		path: componentPagesMenu.components.subMenu.button.path,
		element: <COMPONENTS_PAGE.BUTTON />,
	},
	{
		path: componentPagesMenu.components.subMenu.buttonGroup.path,
		element: <COMPONENTS_PAGE.BUTTON_GROUP />,
	},
	{
		path: componentPagesMenu.components.subMenu.alert.path,
		element: <COMPONENTS_PAGE.ALERT />,
	},
	{
		path: componentPagesMenu.components.subMenu.badge.path,
		element: <COMPONENTS_PAGE.BADGE />,
	},
	{
		path: componentPagesMenu.components.subMenu.popovers.path,
		element: <COMPONENTS_PAGE.POPOVERS />,
	},
	{
		path: componentPagesMenu.components.subMenu.dropdowns.path,
		element: <COMPONENTS_PAGE.DROPDOWN />,
	},
	{
		path: componentPagesMenu.components.subMenu.accordion.path,
		element: <COMPONENTS_PAGE.ACCORDION />,
	},
	{
		path: componentPagesMenu.components.subMenu.modal.path,
		element: <COMPONENTS_PAGE.MODAL />,
	},
	{
		path: componentPagesMenu.components.subMenu.navsTabs.path,
		element: <COMPONENTS_PAGE.NAVS_TABS />,
	},
	{
		path: componentPagesMenu.components.subMenu.offcanvas.path,
		element: <COMPONENTS_PAGE.OFF_CANVAS />,
	},
	{
		path: componentPagesMenu.components.subMenu.table.path,
		element: <COMPONENTS_PAGE.TABLE />,
	},

	/**
	 * Utilities
	 */
	{
		path: componentPagesMenu.utilities.path,
		element: <UTILITIES.UTILITIES />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.api.path,
		element: <UTILITIES.API />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.background.path,
		element: <UTILITIES.BACKGROUND />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.borders.path,
		element: <UTILITIES.BORDERS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.colors.path,
		element: <UTILITIES.COLORS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.display.path,
		element: <UTILITIES.DISPLAY />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.flex.path,
		element: <UTILITIES.FLEX />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.float.path,
		element: <UTILITIES.FLOAT />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.interactions.path,
		element: <UTILITIES.INTERACTIONS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.overflow.path,
		element: <UTILITIES.OVERFLOW />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.position.path,
		element: <UTILITIES.POSITION />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.shadows.path,
		element: <UTILITIES.SHADOWS />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.sizing.path,
		element: <UTILITIES.SIZING />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.spacing.path,
		element: <UTILITIES.SPACING />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.text.path,
		element: <UTILITIES.TEXT />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.verticalAlign.path,
		element: <UTILITIES.VERTICAL_ALIGN />,
	},
	{
		path: componentPagesMenu.utilities.subMenu.visibility.path,
		element: <UTILITIES.VISIBILITY />,
	},

	/**
	 * Extra
	 */

	/**
	 * Icons
	 */
	{
		path: componentPagesMenu.icons.path,
		element: <ICONS.ICONS_LIST />,
	},
	{
		path: componentPagesMenu.icons.subMenu.icon.path,
		element: <ICONS.ICON />,
	},
	{
		path: componentPagesMenu.icons.subMenu.material.path,
		element: <ICONS.MATERIAL />,
	},

	/**
	 * Charts
	 */
	{
		path: componentPagesMenu.charts.path,
		element: <CHARTS_PAGE.CHART_LIST />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsUsage.path,
		element: <CHARTS_PAGE.GENERAL_USAGE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsSparkline.path,
		element: <CHARTS_PAGE.SPARKLINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsLine.path,
		element: <CHARTS_PAGE.LINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsArea.path,
		element: <CHARTS_PAGE.AREA />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsColumn.path,
		element: <CHARTS_PAGE.COLUMN />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBar.path,
		element: <CHARTS_PAGE.BAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsMixed.path,
		element: <CHARTS_PAGE.MIXED />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsTimeline.path,
		element: <CHARTS_PAGE.TIMELINE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsCandleStick.path,
		element: <CHARTS_PAGE.CANDLESTICK />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBoxWhisker.path,
		element: <CHARTS_PAGE.BOX_WHISKER />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsPieDonut.path,
		element: <CHARTS_PAGE.PIE_DONUT />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsRadar.path,
		element: <CHARTS_PAGE.RADAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsPolar.path,
		element: <CHARTS_PAGE.POLAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsRadialBar.path,
		element: <CHARTS_PAGE.RADIAL_BAR />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsBubble.path,
		element: <CHARTS_PAGE.BUBBLE />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsScatter.path,
		element: <CHARTS_PAGE.SCATTER />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsHeatMap.path,
		element: <CHARTS_PAGE.HEAT_MAP />,
	},
	{
		path: componentPagesMenu.charts.subMenu.chartsTreeMap.path,
		element: <CHARTS_PAGE.TREE_MAP />,
	},

	{
		path: componentPagesMenu.notification.path,
		element: <EXTRA.NOTIFICATION />,
	},
	{
		path: componentPagesMenu.hooks.path,
		element: <EXTRA.HOOKS />,
	},
];

const extra: RouteProps[] = [
	// {
	// 	path: '/clerk/dashboard',
	// 	element: <ClerkDashboard />,
	// },
	{
		path: '/products',
		element: <AllProduct />,
	},
	{
		path: '/add/product',
		element: <AddProduct />,
	},
	{
		path: '/edit/product',
		element: <EditProduct />,
	},
	{
		path: '/categories',
		element: <AllCategory />,
	},
	{
		path: '/add/category',
		element: <AddCategory />,
	},
	{
		path: '/edit/category',
		element: <EditCategory />,
	},
	{
		path: '/banner',
		element: <Banner />,
	},
	{
		path: '/add/banner',
		element: <AddBanner />,
	},
	{
		path: '/edit/banner',
		element: <EditBanner />,
	},
	{
		path: '/catering/banner',
		element: <CateringBanner />,
	},
	{
		path: '/add/catering/banner',
		element: <AddCateringBanner />,
	},
	{
		path: '/edit/catering/banner',
		element: <EditCateringBanner />,
	},
	{
		path: '/users',
		element: <AllUsers />,
	},
	{
		path: '/add/users',
		element: <AddUser />,
	},

	{
		path: '/edit/user',
		element: <EditUser />,
	},
	{
		path: '/all-orders',
		element: <AllOrders />,
	},
	{
		path: '/view/order',
		element: <OrderDetail />,
	},
	{
		path: '/edit/order',
		element: <EditOrder />,
	},
	{
		path: '/add/order',
		element: <AddOrder />,
	},

	{
		path: '/all-vendors',
		element: <AllVendors />,
	},
	{
		path: '/edit/vendor',
		element: <EditVendor />,
	},
	{
		path: '/add/vendor',
		element: <AddVendor />,
	},

	{
		path: '/all-eventType',
		element: <AllEventType />,
	},
	{
		path: '/edit/eventType',
		element: <EditEventTpe />,
	},
	{
		path: '/add/eventType',
		element: <AddEventType />,
	},

	{
		path: '/all-foodCatering',
		element: <AllFoodCatering />,
	},
	{
		path: '/edit/foodCatering',
		element: <EditFoodCatering />,
	},
	{
		path: '/add/foodCatering',
		element: <AddFoodCatering />,
	},

	{
		path: '/all-partyCatering',
		element: <AllPartyCatering />,
	},
	{
		path: '/edit/partyCatering',
		element: <EditPartyCatering />,
	},
	{
		path: '/add/partyCatering',
		element: <AddPartyCatering />,
	},
	{
		path: '/all-partyAccessories',
		element: <AllPartyAccessories />,
	},
	{
		path: '/edit/partyAccessory',
		element: <EditPartyAccessories />,
	},
	{
		path: '/add/partyAccessory',
		element: <AddPartyAccessories />,
	},

	{
		path: '/all-cateringPrice',
		element: <AllCateringPrice />,
	},
	{
		path: '/all-booking',
		element: <Booking />,
	},
	{
		path: '/edit/booking',
		element: <EditBooking />,
	},

	{
		path: '/all-cateringOrder',
		element: <CateringOrder />,
	},
	{
		path: '/edit/cateringOrder',
		element: <EditCateringOrder />,
	},

	{
		path: '/all-gifts',
		element: <AllGifts />,
	},
	{
		path: '/edit/gift',
		element: <EditGift />,
	},
	{
		path: '/add/gift',
		element: <AddGift />,
	},

	{
		path: '/all-loyalities',
		element: <AllLoyalities />,
	},
	{
		path: '/edit/loyality',
		element: <EditLoyality />,
	},
];
const contents = [...presentation, ...documentation, ...extra];

export default contents;
